// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","316":"a145e65e","396":"e686f347","453":"d855a71b","455":"e079aaf4","977":"b5623f9a"}[chunkId] + ".chunk.js";
};